import React, { useState, useMemo, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { trackEvent } from "../../hooks/analytics";

import {
  Alert,
  notification,
  Space,
  Checkbox,
  Spin,
  message,
  Divider,
} from "antd";
import { useHistory } from "react-router-dom";

import {
  StyledForm,
  StyledInput,
  StyledLabel,
  MainButtonFull,
} from "../../globalStyles";
import {
  ArrowLeftOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  CheckCircleFilled,
  CloseCircleFilled,
} from "@ant-design/icons";
import { signUp, fetchUserProfile } from "../../redux/actions";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "../../index.css";
import PdfModal from "../../components/PdfModal/PdfModal";
import privacyPdf from "../../images/e-citizen_Nigeria_Privacy_Notice_v2.1_Confirmed.pdf";

import Swal from "sweetalert2";
import { theme } from "antd";
import { useTheme } from "../../components/ThemeProvider";
import { useGoogleLogin } from "@react-oauth/google";
import GoogleSignUpButton from "../../components/sso_button/googleSignUpButton";
import baseUrl from "../../apiConfig";
import { apiPostInternalCall } from "../../apiUtils";
import GoogleSignInButton from "../../components/sso_button/googleSignInButton";
import FacebookSignInButton from "../../components/sso_button/facebookSignInButton";
import AppleSignInButton from "../../components/sso_button/appleSignInButton";
import FacebookLogin from "react-facebook-login";
import { FACEBOOK_APP_ID } from "../../config/facebook";
import AppleLogin from "react-apple-login";
import { apiPost } from "../../apiUtils";
import { trackGA4Event } from "../../hooks/analytics";
import {
  BackLink,
  FormSubtitle,
  FormTitle,
  SignUpCard,
  SignUpShell,
  AppleLabel,
  AppleInput,
  AppleButton,
  PasswordHintList,
  PasswordInputWrapper,
  EyeIconContainer,
  PasswordHintItem,
} from "./SignUp.elements";

const IndividualSignUp = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [userType, setUserType] = useState("");
  const [ipAddress, setIpAddress] = useState("");
  const [ipCountry, setIpCountry] = useState("");
  const firstNameRef = useRef(null);
  const lastNameRef = useRef(null);
  const ninRef = useRef(null);
  const emailRef = useRef(null);
  const phoneNumberRef = useRef(null);
  const passwordRef = useRef(null);
  const [reenterPassword, setReenterPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showReenterPassword, setShowReenterPassword] = useState(false);
  const [phone, setPhone] = useState("");
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    nin: "",
    phoneNumber: "",
    email: "",
    password: "",
    rememberMe: false,
    userType: "",
    ipAddress: "",
    ipCountry: "",
    emailMarketingConsent: true,
    channel: "Web",
    preferredLanguage: "English",
  });

  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);

  const handlePhoneChange = (phone) => {
    // Update state using setPhone

    setPhone(phone);
    setFormData({
      ...formData,
      phoneNumber: phone,
    });
  };
  const [isFocused, setIsFocused] = useState(false);
  const handleFocus = () => {
    setIsFocused(true);
  };

  const [api, contextHolder] = notification.useNotification();

  const openNotification = (placement) => {
    api.info({
      message: `Notification`,
      description: "response.message",
      placement,
    });
  };

  const contextValue = useMemo(
    () => ({
      name: "Ant Design",
    }),
    [],
  );

  const focusOnErrorField = (fieldName) => {
    switch (fieldName) {
      case "firstName":
        firstNameRef.current.focus();
        break;
      case "lastName":
        lastNameRef.current.focus();
        break;
      case "nin":
        ninRef.current.focus();
        break;
      case "email":
        emailRef.current.focus();
        break;
      // case "phoneNumber":
      //   phoneNumberRef.current.focus();
      //   break;
      case "password":
        passwordRef.current.focus();
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    const fetchIpCountry = async () => {
      try {
        const response = await axios.get("https://ipapi.co/json/");
        setIpCountry(response.data.country_name);
        setIpAddress(response.data.ip);
      } catch (error) {
        console.error("Error fetching IP address:", error);
        setIpCountry(null);
      }
    };

    fetchIpCountry();
  }, []);

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    const inputValue = type === "checkbox" ? checked : value;

    if (name === "reenterPassword") {
      setReenterPassword(value);
    }

    setFormData({
      ...formData,
      [name]: inputValue,
      userType: "individual",
      ipAddress: ipAddress,
      ipCountry: ipCountry,
    });

    setFormErrors({
      ...formErrors,
      [name]: null,
    });
  };

  const validatePassword = (password) => {
    const errors = [];

    if (!password) {
      errors.push("Please enter your password");
    }
    if (password.length < 8) {
      errors.push("Password must be 8 characters or more");
    }
    if (!/[A-Z]/.test(password)) {
      errors.push("Password must contain at least one capital letter");
    }
    if (!/[a-z]/.test(password)) {
      errors.push("Password must contain at least one lowercase letter");
    }
    if (!/\d/.test(password)) {
      errors.push("Password must contain at least one number");
    }
    if (!/[^a-zA-Z0-9]/.test(password)) {
      errors.push("Password must contain at least one special character");
    }

    return errors.join(". "); // Join errors into a single string with a dot and space separator
  };

  const passwordErrorMessage = validatePassword(formData.password);

  const validateForm = () => {
    const errors = {};
    // First Name
    if (!formData.firstName) {
      errors.firstName = "Please enter your first name";
    }

    // Last Name
    if (!formData.lastName) {
      errors.lastName = "Please enter your last name";
    }

    if (!formData.email) {
      errors.email = "Please enter your email";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formData.email)
    ) {
      errors.email = "Invalid email format";
    }

    if (!formData.password) {
      errors.password = "Please enter your password";
    } else if (formData.password.length < 8) {
      errors.password = "Password must be 8 characters or more";
    } else if (!/[A-Z]/.test(formData.password)) {
      errors.password = "Password must contain at least one capital letter";
    } else if (!/[a-z]/.test(formData.password)) {
      errors.password = "Password must contain at least one lowercase letter";
    } else if (!/\d/.test(formData.password)) {
      errors.password = "Password must contain at least one number";
    } else if (!/[^a-zA-Z0-9]/.test(formData.password)) {
      errors.password = "Password must contain at least one special character";
    }

    return errors;
  };

  const handleSignUp = async (event) => {
    trackEvent({
      action: "click_individual_signup_form_attempt",
      category: "Account Creation Attempt",
      label: "Individual Signup Form Attempt",
      value: 1,
    });
    event.preventDefault();

    try {
      const errors = validateForm();
      if (Object.keys(errors).length > 0) {
        setFormErrors(errors);
        const firstErrorField = Object.keys(errors)[0];
        focusOnErrorField(firstErrorField); // Focus on the first error field
        return;
      }

      if (formData.password !== reenterPassword) {
        setFormErrors({ reenterPassword: "Passwords do not match" });
        focusOnErrorField("reenterPassword");
        return;
      }

      setFormErrors({});
      setLoading(true);

      const payload = {
        ...formData,
        emailMarketingConsent: true,
        channel: "Web",
        preferredLanguage: "English",
      };

      // Assuming signIn action returns a promise that resolves with the user data
      const response = await dispatch(signUp(payload));
      const openNotification2 = (placement) => {
        api.error({
          message: `Notification`,
          description: response.message,
          placement,
        });
      };
      setLoading(true);
      localStorage.setItem("formData", JSON.stringify(payload));

      // if (response.status !== 200) {
      //   throw new Error(response); // Throw an error with the response status text
      // }

      if (response?.status === "success") {
        // On successful sign up, fire GA4 event

        trackGA4Event("sign_up", { method: "email" });
        // On successful login, navigate to the main dashboard
        trackEvent({
          action: "click_individual_signup_form_success",
          category: "Account Creation Success",
          label: "Individual Signup Form Success",
          value: 1,
        });
        Swal.fire({
          background: bgContainer,
          color: text,
          title: "Success",
          text: response.message,
          icon: "success",
          customClass: {
            confirmButton: "custom-swal-button",
          },
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then(() => {
          history.push("/verify-otp");
        });
      } else {
        setFormErrors({ general: response.message }); // Set error message
        // openNotification2("topRight");
        Swal.fire({
          background: bgContainer,
          color: text,
          title: "Error",
          text: response?.message || "Sign up failed. Please try again.",
          icon: "error",
          customClass: {
            confirmButton: "custom-swal-button",
          },
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      }
    } catch (error) {
      console.error("SignUp failed:", error);
      Swal.fire({
        background: bgContainer,
        color: text,
        title: "Error",
        text: "Sign up failed. Please try again.",
        icon: "error",
        customClass: {
          confirmButton: "custom-swal-button",
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    } finally {
      setLoading(false);
    }
  };
  const [isOpen, setIsOpen] = useState(false);
  const handleClickPrivacyPolicy = () => {
    setIsOpen(true);
  };
  const [isAccepted, setIsAccepted] = useState(false);

  const onChangeIsAccepted = (e) => {
    e.target.checked ? setIsAccepted(true) : setIsAccepted(false);
  };

  const { token } = theme.useToken();
  const { bgContainer, text } = token;

  const login = useGoogleLogin({
    onSuccess: async (response) => {
      try {
        const payload = {
          accessToken: response.access_token,
          deviceToken: localStorage.getItem("clientToken"),
          ipAddress: ipAddress,
          deviceName: "Web app",
          platform: "ng",
        };

        const res = await apiPostInternalCall(
          `/openauth/google-login`,
          payload,
        );
        const userData = res.data;
        Swal.fire({
          background: bgContainer,
          color: text,
          title: "Success",
          text: "Google login successful!",
          icon: "success",
          customClass: {
            confirmButton: "custom-swal-button",
          },
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        dispatch({
          type: "SIGN_IN",
          payload: userData,
        });
        dispatch(fetchUserProfile(userData.jwtToken));

        if (userData.jwtToken) {
          localStorage.setItem("IpAddress", ipAddress);
          history.push("/main-dashboard");
        } else {
          Swal.fire({
            background: bgContainer,
            color: text,
            title: "Error",
            text: "Login failed",
            icon: "error",
            customClass: {
              confirmButton: "custom-swal-button",
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
          // openNotification2("topRight");
        }
      } catch (error) {
        console.error("Google login failed:", error);

        let errorMessage = "Google login failed. Please try again.";

        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.error("Server responded with status:", error.response.status);
          if (error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
          }
        } else if (error.request) {
          // The request was made but no response was received
          console.error("No response received from server:", error.request);
          errorMessage = "Network error. Please check your connection.";
        } else {
          // Something happened in setting up the request that triggered an Error
          console.error("Error setting up request:", error.message);
        }
        Swal.fire({
          background: bgContainer,
          color: text,
          title: "Error",
          text: errorMessage,
          icon: "error",
          customClass: {
            confirmButton: "custom-swal-button",
          },
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      }
    },
  });

  const handleFacebook = async (fbRes) => {
    // User cancelled or popup blocked
    if (!fbRes || !fbRes.accessToken) {
      Swal.fire({
        background: bgContainer,
        color: text,
        title: "Facebook Login",
        text: "Facebook login was cancelled or failed.",
        icon: "error",
        customClass: { confirmButton: "custom-swal-button" },
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
      return;
    }

    try {
      setLoading(true);

      const payload = {
        accessToken: fbRes.accessToken,
        // userId: fbRes.userID,
        deviceToken: localStorage.getItem("clientToken"),
        ipAddress: ipAddress,
        deviceName: "Web app",
        platform: "ng",
      };

      const resfb = await apiPost(`/openauth/facebook`, payload);
      const userDataFb = resfb;
      Swal.fire({
        background: bgContainer,
        color: text,
        title: "Success",
        text: "Facebook login successful!",
        icon: "success",
        customClass: { confirmButton: "custom-swal-button" },
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      dispatch({ type: "SIGN_IN", payload: userDataFb });
      dispatch(fetchUserProfile(userDataFb.jwtToken));

      if (userDataFb.jwtToken) {
        localStorage.setItem("IpAddress", ipAddress);
        history.push("/main-dashboard");
      } else {
        throw new Error("Login failed");
      }
    } catch (err) {
      console.error("Facebook login failed:", err);
      Swal.fire({
        background: bgContainer,
        color: text,
        title: "Error",
        text:
          err?.response?.data?.message ||
          "Facebook login failed. Please try again.",
        icon: "error",
        customClass: { confirmButton: "custom-swal-button" },
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const pwd = formData.password || "";
  const isLengthValid = pwd.length >= 8;
  const isCaseValid = /[A-Z]/.test(pwd) && /[a-z]/.test(pwd);
  const isNumberValid = /\d/.test(pwd);
  const isSpecialValid = /[^a-zA-Z0-9]/.test(pwd);

  return (
    <SignUpShell>
      <SignUpCard style={{ maxWidth: "620px" }}>
        <FormTitle style={{ textAlign: "center" }}>
          Create your account
        </FormTitle>
        <FormSubtitle style={{ textAlign: "center", marginBottom: "24px" }}>
          Enter your details to start verifying with e-Citizen.
        </FormSubtitle>

        <Space size="large" direction="vertical" style={{ display: "flex" }}>
          <Spin spinning={loading} tip="Signing Up...">
            <StyledForm onSubmit={handleSignUp}>
              <style>
                {`
          .facebook-btn {
           display: flex;
            align-items: center;
            width: 100%;
            justify-content: center;
            padding: 10px 20px;
            border: 1px solid #000;
            border-radius: 4px;
            background-color: white;
            color: #000;
            font-weight: 500;
            font-size: 14px;
            cursor: pointer;
            transition: box-shadow 0.3s ease;
            border-radius: 8px;
          }

          .facebook-btn:hover {
           box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
          }
        `}
              </style>
              <Space direction="vertical" style={{ width: "100%" }}>
                <GoogleSignInButton
                  onClick={(e) => {
                    e.preventDefault();
                    localStorage.removeItem("token");
                    // 🔍 Track the click event
                    trackEvent({
                      action: "click_google_signin",
                      category: "Authentication",
                      label: "Google Sign-In Button",
                      value: 1,
                    });
                    login();
                  }}
                />
                <FacebookLogin
                  appId={FACEBOOK_APP_ID}
                  autoLoad={false}
                  fields="name,email,picture"
                  scope="public_profile,email"
                  redirectUri="https://e-citizen.ng/verification-login"
                  responseType="code"
                  callback={handleFacebook}
                  cssClass="facebook-btn"
                  textButton="Continue with Facebook"
                  icon={<FacebookSignInButton />}
                />
                {/*  <AppleLogin
                      clientId="com.react.apple.login"
                      redirectURI="https://redirectUrl.com"
                      responseType="code"
                      responseMode="query"
                      usePopup={true}
                      callback={(response) => {
                        console.log("Apple login response:", response);
                        // handle login here
                      }}
                      render={({ onClick }) => (
                        <AppleSignInButton onClick={onClick} />
                      )}
                    /> */}
              </Space>
              <Divider>OR</Divider>
              {formErrors.general && (
                <Alert
                  message={formErrors.general}
                  type="error"
                  showIcon
                  style={{ marginBottom: "16px" }}
                />
              )}
              <AppleLabel $token={token}>First name</AppleLabel>
              <AppleInput
                $token={token}
                type="text"
                placeholder="Enter your first name"
                name="firstName"
                value={formData.firstName}
                onChange={handleInputChange}
                ref={firstNameRef}
              />
              {formErrors.firstName && (
                <Alert message={formErrors.firstName} type="error" showIcon />
              )}

              <AppleLabel $token={token}>Last name</AppleLabel>
              <AppleInput
                $token={token}
                type="text"
                placeholder="Enter your last name"
                name="lastName"
                value={formData.lastName}
                onChange={handleInputChange}
                ref={lastNameRef}
              />
              {formErrors.lastName && (
                <Alert message={formErrors.lastName} type="error" showIcon />
              )}

              <AppleInput
                $token={token}
                hidden
                type="text"
                placeholder="Enter your NIN"
                name="nin"
                value={formData.nin}
                onChange={handleInputChange}
                pattern="[0-9]*" // Allow only numbers
                title="Please enter only numbers"
                ref={ninRef}
              />
              {/* {formErrors.nin && (
                    <Alert message={formErrors.nin} type="error" showIcon />
                  )} */}
              <AppleLabel $token={token}>Email address</AppleLabel>
              <AppleInput
                $token={token}
                type="text"
                placeholder="Enter your Email address"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                ref={emailRef}
              />
              {formErrors.email && (
                <Alert message={formErrors.email} type="error" showIcon />
              )}
              <AppleLabel $token={token}>
                Phone number (E.g: +234 81X XXX XXX X)
              </AppleLabel>
              <PhoneInput
                $token={token}
                country={"ng"}
                value={formData.phoneNumber}
                onChange={handlePhoneChange}
                enableSearch
                onFocus={handleFocus}
                className={"input-phone-number mb-3"}
                inputStyle={{
                  width: "100%",
                  height: "52px",
                  borderColor: isFocused ? "#09c93a" : "transparent",
                  borderWidth: "1.5px",
                  borderStyle: "solid",
                  borderRadius: "12px",
                  color: text,
                  background: "var(--ec-input-bg, rgba(0, 0, 0, 0.04))",
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                  fontSize: "15px",
                }}
                buttonStyle={{
                  border: "none",
                  background: "transparent",
                  borderRadius: "12px 0 0 12px",
                  paddingLeft: "8px",
                }}
              />

              {formErrors.phoneNumber && (
                <Alert message={formErrors.phoneNumber} type="error" showIcon />
              )}

              <AppleLabel $token={token}>Password</AppleLabel>
              <PasswordInputWrapper>
                <AppleInput
                  $token={token}
                  type={showPassword ? "text" : "password"}
                  placeholder="Create a password"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  ref={passwordRef}
                />
                <EyeIconContainer
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                </EyeIconContainer>
              </PasswordInputWrapper>

              <PasswordHintList>
                <PasswordHintItem $valid={isLengthValid}>
                  {isLengthValid ? (
                    <CheckCircleFilled />
                  ) : (
                    <CloseCircleFilled />
                  )}{" "}
                  At least 8 characters long
                </PasswordHintItem>
                <PasswordHintItem $valid={isCaseValid}>
                  {isCaseValid ? <CheckCircleFilled /> : <CloseCircleFilled />}{" "}
                  1 uppercase and 1 lowercase letter
                </PasswordHintItem>
                <PasswordHintItem $valid={isNumberValid}>
                  {isNumberValid ? (
                    <CheckCircleFilled />
                  ) : (
                    <CloseCircleFilled />
                  )}{" "}
                  1 number
                </PasswordHintItem>
                <PasswordHintItem $valid={isSpecialValid}>
                  {isSpecialValid ? (
                    <CheckCircleFilled />
                  ) : (
                    <CloseCircleFilled />
                  )}{" "}
                  1 special character
                </PasswordHintItem>
              </PasswordHintList>

              {formErrors.password && (
                <Alert
                  message={passwordErrorMessage}
                  type="error"
                  showIcon
                  style={{ marginBottom: "20px" }}
                />
              )}

              <AppleLabel $token={token}>Confirm Password</AppleLabel>
              <PasswordInputWrapper>
                <AppleInput
                  $token={token}
                  type={showReenterPassword ? "text" : "password"}
                  placeholder="Re-enter the password"
                  name="reenterPassword"
                  value={reenterPassword}
                  onChange={handleInputChange}
                />
                <EyeIconContainer
                  onClick={() => setShowReenterPassword(!showReenterPassword)}
                >
                  {showReenterPassword ? (
                    <EyeInvisibleOutlined />
                  ) : (
                    <EyeOutlined />
                  )}
                </EyeIconContainer>
              </PasswordInputWrapper>
              {formErrors.reenterPassword && (
                <Alert
                  message={formErrors.reenterPassword}
                  type="error"
                  showIcon
                />
              )}
              <Checkbox onChange={onChangeIsAccepted}>
                I certify that I have read and accepted the{" "}
                <span
                  style={{ color: "#09C93A", cursor: "pointer" }}
                  onClick={handleClickPrivacyPolicy}
                >
                  e-citizen™ Privacy Policy
                </span>
              </Checkbox>
              <PdfModal
                open={isOpen}
                onClose={() => setIsOpen(false)}
                title="Privacy Policy"
                src={privacyPdf}
                height={560}
              />

              <AppleButton
                type="primary"
                htmlType="submit"
                disabled={!isAccepted}
                style={
                  isAccepted
                    ? {}
                    : {
                        marginTop: "10px",
                        backgroundColor: "gray",
                        color: "white",
                        cursor: "not-allowed",
                      }
                }
              >
                Proceed
              </AppleButton>

              <p
                style={{
                  textAlign: "center",
                  marginTop: "16px",
                  fontSize: "14px",
                  color: "#6b7280",
                }}
              >
                Already have an account?{" "}
                <span
                  onClick={() => history.push("/login")}
                  style={{
                    color: "#09c93a",
                    fontWeight: "600",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                >
                  Log in
                </span>
              </p>
            </StyledForm>
          </Spin>
        </Space>
      </SignUpCard>
    </SignUpShell>
  );
};

export default IndividualSignUp;
